// 引用カード生成（書籍メモから印象的な一節をカード化）
import { escapeHtml, screenHead, showScreen, toast } from '../ui.js';

export function showQuoteCardScreen(book, analysisText = '') {
  const sourceText = (book.note || '').trim() || analysisText || '';
  const html = `
    ${screenHead('引用カード')}
    <p style="color:var(--dim);font-size:13px;line-height:1.75;margin:0 0 24px;">
      心に残った一節を入力すると、ミニマルなカードに整えます。PNG として保存できます。
    </p>
    <div class="form-group">
      <label class="form-label">引用する文章</label>
      <textarea class="form-textarea" id="quote-text" rows="5" placeholder="ここに一節を貼り付け">${escapeHtml(sourceText.slice(0, 300))}</textarea>
    </div>
    <div id="quote-preview-wrap"></div>
    <button class="btn btn--block" id="btn-preview" type="button" style="margin-top:8px;">
      <svg class="icon"><use href="#i-eye"/></svg>
      <span>プレビュー</span>
    </button>
    <button class="btn btn--ink btn--block" id="btn-download" type="button" style="margin-top:8px;">
      <svg class="icon"><use href="#i-download"/></svg>
      <span>PNG として保存</span>
    </button>
  `;
  const screen = showScreen('quote-card', html);
  screen.querySelector('[data-action="back"]').addEventListener('click', () => window.history.back());

  function renderPreview() {
    const text = screen.querySelector('#quote-text').value.trim();
    const wrap = screen.querySelector('#quote-preview-wrap');
    if (!text) {
      wrap.innerHTML = '';
      return;
    }
    wrap.innerHTML = `
      <div class="quote-canvas" id="quote-canvas">
        <p class="quote-canvas__mark">"</p>
        <p class="quote-canvas__text">${escapeHtml(text)}</p>
        <div>
          <p class="quote-canvas__meta">${escapeHtml(book.name || '')}</p>
          ${book.author ? `<p class="quote-canvas__meta" style="margin-top:2px;">${escapeHtml(book.author)}</p>` : ''}
          <p class="quote-canvas__meta" style="margin-top:8px;letter-spacing:0.32em;">lectio</p>
        </div>
      </div>
    `;
  }

  screen.querySelector('#btn-preview').addEventListener('click', renderPreview);
  screen.querySelector('#btn-download').addEventListener('click', async () => {
    renderPreview();
    const canvas = screen.querySelector('#quote-canvas');
    if (!canvas) {
      toast('文章を入力してください');
      return;
    }
    await exportAsImage(canvas, `lectio-quote-${Date.now()}.png`);
  });
  renderPreview();
}

// foreignObject 経由で SVG → PNG 化（追加ライブラリなし）
async function exportAsImage(domNode, filename) {
  const rect = domNode.getBoundingClientRect();
  const scale = 2; // Retina
  const w = Math.round(rect.width);
  const h = Math.round(rect.height);
  const clone = domNode.cloneNode(true);
  // 計算済み style をインラインに焼き込む
  inlineComputedStyle(domNode, clone);

  const xmlSerializer = new XMLSerializer();
  const html = xmlSerializer.serializeToString(clone);

  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="${h}">
      <foreignObject width="100%" height="100%">
        <div xmlns="http://www.w3.org/1999/xhtml" style="width:${w}px;height:${h}px;">${html}</div>
      </foreignObject>
    </svg>
  `;

  const svgBlob = new Blob([svg], { type: 'image/svg+xml;charset=utf-8' });
  const url = URL.createObjectURL(svgBlob);
  const img = new Image();
  img.crossOrigin = 'anonymous';
  await new Promise((resolve, reject) => {
    img.onload = resolve;
    img.onerror = reject;
    img.src = url;
  });
  const canvas = document.createElement('canvas');
  canvas.width = w * scale;
  canvas.height = h * scale;
  const ctx = canvas.getContext('2d');
  ctx.scale(scale, scale);
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, w, h);
  ctx.drawImage(img, 0, 0);
  URL.revokeObjectURL(url);
  canvas.toBlob((blob) => {
    if (!blob) return;
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(a.href), 100);
    toast('PNG を書き出しました');
  }, 'image/png');
}

function inlineComputedStyle(src, dst) {
  const cs = window.getComputedStyle(src);
  let str = '';
  // 必要な css プロパティのみ inline 化（パフォーマンスのため厳選）
  const props = [
    'font-family', 'font-size', 'font-weight', 'font-style', 'letter-spacing',
    'line-height', 'color', 'background', 'background-color', 'border', 'border-radius',
    'padding', 'margin', 'display', 'flex-direction', 'justify-content', 'align-items',
    'width', 'height', 'box-sizing', 'aspect-ratio', 'text-align', 'white-space', 'word-break'
  ];
  for (const p of props) str += `${p}: ${cs.getPropertyValue(p)};`;
  dst.setAttribute('style', str);
  const srcKids = src.children;
  const dstKids = dst.children;
  for (let i = 0; i < srcKids.length; i++) {
    inlineComputedStyle(srcKids[i], dstKids[i]);
  }
}
